<template>
  <v-app>
    <v-app-bar 
      app
      elevation="0"
      class="rec-navbar"
    >
      <img
        alt="logo"
        class="ebc-logo"
        :src="require('./assets/ebc-logo.svg')"
        width="120"
      />
    </v-app-bar>
    
    <v-main>
      <nav class="rec-separator" ></nav>
      <div class="container">
        <router-view/>
      </div>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'App',

  components: {

  },

  data: () => ({
    //
  }),
};
</script>

<style lang="scss">
  .rec-navbar {
    border: 1px solid transparent;
  }

  .rec-separator{
    position: relative;
    min-height: 50px;
    margin-bottom: 20px;
    border: 1px solid transparent;
    background-color: #005A8F;
  }

  .pr-loader{
    margin: 10px;
  }

  [v-cloak] {
    display: none;
  }
</style>